import { Link } from "react-router-dom";
import { resolveImg, safeHref } from "@/lib/api";
import { SOCIAL_PLATFORMS } from "@/components/site/SocialIcons";

export default function Footer({ content = {} }) {
  const socials = SOCIAL_PLATFORMS.filter((p) => safeHref(content[p.key]));
  return (
    <footer data-testid="site-footer" className="bg-upland-offwhite border-t border-upland-brown/20 py-12">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          {content.logo_full_url ? (
            <img src={resolveImg(content.logo_full_url)} alt="Upland Group" width="64" height="64" className="h-16 w-auto object-contain" data-testid="footer-logo" />
          ) : (
            <>
              <span className="h-8 w-8 grid place-items-center border border-upland-green text-upland-green font-serif">U</span>
              <span className="font-serif text-lg text-upland-green">Upland Group</span>
            </>
          )}
        </div>
        <div className="flex flex-col items-center gap-1">
          <a href="tel:+18447271001" data-testid="footer-phone" className="text-sm text-upland-green link-underline hover:text-upland-brown">(844) 727-1001</a>
          <p className="text-xs text-upland-grey">© {new Date().getFullYear()} Upland Group LLC. All rights reserved.</p>
        </div>
        <div className="flex items-center gap-5">
          <Link to="/assessment" data-testid="footer-assessment-link" className="text-sm text-upland-grey link-underline hover:text-upland-green">Client Assessment</Link>
          <Link to="/legal/privacy" data-testid="footer-privacy-link" className="text-sm text-upland-grey link-underline hover:text-upland-green">Privacy</Link>
          <Link to="/legal/privacy#privacy-choices" data-testid="footer-privacy-choices-link" className="text-sm text-upland-grey link-underline hover:text-upland-green">Your Privacy Choices</Link>
          <Link to="/legal/terms" data-testid="footer-terms-link" className="text-sm text-upland-grey link-underline hover:text-upland-green">Terms</Link>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-sm text-upland-grey link-underline hover:text-upland-green">Employee Portal</Link>
        </div>
      </div>
      {socials.length > 0 && (
        <div data-testid="footer-social-icons" className="max-w-7xl mx-auto px-6 md:px-12 mt-8 pt-6 border-t border-upland-brown/10 flex items-center justify-center gap-6">
          {socials.map(({ key, label, Icon }) => (
            <a key={key} href={safeHref(content[key])} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}
              data-testid={`footer-social-${key.replace("social_", "").replace(/_/g, "-")}`}
              className="text-upland-grey hover:text-upland-green transition-colors">
              <Icon />
            </a>
          ))}
        </div>
      )}
    </footer>
  );
}
